import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "loading-container"
};
import constants from '@/constants';
import { useLess } from '@/models/hooks';
export default {
  __name: 'Loading',
  setup(__props) {
    useLess('components/loading.less');
    var IMAGE_URL = constants.IMAGE_URL;
    // import picture
    var loadingImg = `${IMAGE_URL}assets/image/amzLoading.png`;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: loadingImg,
        alt: ""
      })]);
    };
  }
};